import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./Login.css"; // Reusing login styles

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Get the email from the URL (e.g., ?email=user@example.com)
  const email = searchParams.get("email");

  const handleReset = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    if (!email) {
      alert("Invalid link. Email is missing.");
      return;
    }

    try {
      const response = await fetch("https://meetra-green-energy-backend.onrender.com/api/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, newPassword: password }),
      });

      const data = await response.json();

      if (response.ok) {
        alert("✅ Password updated successfully! Please login.");
        navigate("/login");
      } else {
        alert(data.error || "Failed to reset password.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Server error. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2 style={{ textAlign: "center", color: "#0b3b5c", marginBottom: "20px" }}>Set New Password</h2>
        
        <form onSubmit={handleReset}>
          <div className="form-group">
            <input 
              type="password" 
              placeholder="New Password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required
            />
          </div>

          <div className="form-group">
            <input 
              type="password" 
              placeholder="Confirm New Password" 
              value={confirmPassword} 
              onChange={(e) => setConfirmPassword(e.target.value)} 
              required
            />
          </div>

          <button type="submit" className="login-btn">Update Password</button>
        </form>
      </div>
    </div>
  );
}